import { apiClient } from './client';

export async function getExternalProviders(params = {}) {
  const { data } = await apiClient.get('/api/system/external-providers', { params });
  return data;
}

export async function createExternalProvider(payload) {
  const { data } = await apiClient.post('/api/system/external-providers', payload);
  return data.data;
}

export async function updateExternalProvider(id, payload) {
  const { data } = await apiClient.put(`/api/system/external-providers/${id}`, payload);
  return data.data;
}

export async function activateExternalProvider(id) {
  const { data } = await apiClient.patch(`/api/system/external-providers/${id}/activate`);
  return data.data;
}

export async function deactivateExternalProvider(id) {
  const { data } = await apiClient.patch(`/api/system/external-providers/${id}/deactivate`);
  return data.data;
}

export async function runExternalProviderHealthCheck(id) {
  const { data } = await apiClient.post(`/api/system/external-providers/${id}/health-check`);
  return data.data;
}

export async function sendExternalProviderTestEmail(id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/external-providers/${id}/send-test-email`, payload);
  return data.data;
}

export async function getExternalProviderHealthChecks(id, params = {}) {
  const { data } = await apiClient.get(`/api/system/external-providers/${id}/health-checks`, { params });
  return data;
}

export async function getExternalProviderUsageLogs(id, params = {}) {
  const { data } = await apiClient.get(`/api/system/external-providers/${id}/usage-logs`, { params });
  return data;
}

export async function getExternalProviderHealthSummary() {
  const { data } = await apiClient.get('/api/system/external-provider-health');
  return data.data;
}

export async function getTenantStoragePaths(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/storage-paths`);
  return data.data;
}

export async function runTenantStorageSmokeTest(tenantId) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/storage/smoke-test`);
  return data.data;
}
